import React from 'react';

var _extends = Object.assign || function (target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];

    for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  }

  return target;
};

function _objectWithoutProperties(obj, keys) {
  var target = {};

  for (var i in obj) {
    if (keys.indexOf(i) >= 0) continue;
    if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;
    target[i] = obj[i];
  }

  return target;
}
var JetChartersIcon = (function (_ref) {
  var _ref$styles = _ref.styles,
      props = _objectWithoutProperties(_ref, ["styles"]);

  return React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "32",
    height: "32",
    viewBox: "0 0 32 32"
  }, props), React.createElement("g", {
    fillRule: "evenodd"
  }, React.createElement("path", {
    fill: "#fff",
    d: "M0 0h32v32H0z"
  }), React.createElement("path", {
    fillRule: "nonzero",
    d: "M14.862 27.962a.999.999 0 0 1-.852-1.128.999.999 0 0 1 1.128-.853c9.186 1.277 14.153-2.112 13.176-7.584-2.21 1.616-5.291 2.503-9.289 2.603A1.002 1.002 0 0 1 18 20.025 1.002 1.002 0 0 1 18.975 19c8.89-.222 12.4-4.517 11.5-12.896-2.23 3.212-5.83 4.978-12.743 7.259-.59.194-.877.29-1.178.39-9.168 3.044-12.967 5.78-14.582 12.481a1 1 0 0 1-1.944-.468c1.007-4.183 3.117-7.242 6.299-9.534 2.429-1.748 4.988-2.847 9.596-4.378l1.183-.39c8.11-2.676 11.19-4.497 12.969-8.843.375-.916 1.711-.788 1.906.183 1.24 6.192.628 10.94-1.986 14.031 2.272 7.67-4.128 12.656-15.133 11.127z"
  })));
});

export default JetChartersIcon;
//# sourceMappingURL=jet-charters.svg.js.map
